import { GoTriangleLeft } from '@react-icons/all-files/go/GoTriangleLeft';
import { GoTriangleRight } from '@react-icons/all-files/go/GoTriangleRight';
import React from 'react';
export const TriangleRight = ({ style }) => <GoTriangleRight style={style}/>;
export const TriangleLeft = ({ style }) => <GoTriangleLeft style={style}/>;
